// src/router/routes.jsx
import React, { lazy, Suspense } from 'react';
import RouteGuard from './RouteGuard';
import { PlayCircleOutlined, ProductOutlined, GlobalOutlined, UserOutlined, FileTextOutlined, FileDoneOutlined, PictureOutlined } from '@ant-design/icons';
import SvgIcon from '@/components/SvgIcon';

// 按需懒加载组件
const App = lazy(() => import('../App'));
const Home = lazy(() => import('../pages/Home'));
const Login = lazy(() => import('../pages/Login'));
const NotFound = () => <div>404 - Not Found</div>;

// 通用的 Suspense 包装器
function withSuspense(Component) {
  return (
    <Suspense>
      <Component />
    </Suspense>
  );
}

const routes = [
  {
    path: '/',
    element: <RouteGuard>{withSuspense(App)}</RouteGuard>,
    children: [
      // {
      //   index: true,
      //   title: 'Dashboard',
      //   icon: <ProductOutlined />,
      //   element: withSuspense(Home),
      // },
      {
        path: 'video',
        icon: <PlayCircleOutlined />,
        title: 'System Videos',
        groupKey: 'videos',
        element: withSuspense(lazy(() => import('../pages/Video'))),
      },
      {
        path: 'ivideo',
        title: 'iVideos',
        groupKey: 'videos',
        element: withSuspense(lazy(() => import('../pages/Ivideo'))),
      },
      {
        path: 'tutorials',
        title: 'Tutorials',
        groupKey: 'videos',
        element: withSuspense(lazy(() => import('../pages/Tutorials'))),
      },
      {
        path: 'video/detail',
        hide: true,
        title: 'Video Detail',
        parentPath: 'video',
        element: withSuspense(lazy(() => import('../pages/Video/components/Detail'))),
      },
      {
        path: 'train',
        icon: <FileTextOutlined />,
        title: 'Training processes ',
        element: withSuspense(lazy(() => import('../pages/Train'))),
      },
      {
        path: 'train/detail',
        hide: true,
        title: 'Training processes Detail',
        parentPath: 'train',
        element: withSuspense(lazy(() => import('../pages/Train/components/Detail'))),
      },

      {
        path: 'users',
        icon: <SvgIcon name="users" />,
        title: 'Users',
        element: withSuspense(lazy(() => import('../pages/Users'))),
      },
      {
        path: 'business',
        icon: <FileTextOutlined />,
        title: 'Business',
        element: withSuspense(lazy(() => import('../pages/Business'))),
      },

      {
        path: 'addCoach',
        icon: <FileDoneOutlined />,
        title: 'Coach White List',
        element: withSuspense(lazy(() => import('../pages/AddCoach'))),
      },
      {
        path: 'sponsorCampaigns',
        title: 'Campaigns',
        icon: <PictureOutlined />,
        groupKey: 'sponsor Slot',
        element: withSuspense(lazy(() => import('../pages/SponsorCampaigns'))),
      },
      {
        path: 'sponsorCampaigns/detail',
        hide: true,
        title: 'Campaign Detail',
        parentPath: 'sponsorCampaigns',
        element: withSuspense(lazy(() => import('../pages/SponsorCampaigns/Detail'))),
      },
      {
        path: 'sponsorSetting',
        title: 'Settings',
        groupKey: 'sponsor Slot',
        element: withSuspense(lazy(() => import('../pages/SponsorSetting'))),
      },
      {
        path: 'sponsorReport',
        title: 'Reporting',
        groupKey: 'sponsor Slot',
        element: withSuspense(lazy(() => import('../pages/SponsorReport'))),
      },

      // {
      //   path: 'lan',
      //   icon: <GlobalOutlined />,
      //   title: 'Languages',
      //   element: withSuspense(lazy(() => import('../pages/Lan'))),
      // },
      // {
      //   path: 'admin',
      //   icon: <UserOutlined />,
      //   title: 'Administrator',
      //   element: withSuspense(lazy(() => import('../pages/Admin'))),
      // },
    ],
  },
  {
    path: '/login',
    element: withSuspense(Login),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
